export const navigations = [
    // {
    //     name: 'Test PDF',
    //     path: '/admin/testPDF',
    //     icon: 'dashboard',
    //     role: ['SA', 'admin'],
    // },
    {
        name: 'Products',
        path: '/dashboard/default',
        icon: 'dashboard',
        role: ['SA', 'admin'],
    },
    {
        name: 'Orders',
        path: '/orders',
        icon: 'dashboard',
        role: ['SA', 'admin'],
    },
    {
        name: 'Prodcut Types',
        path: '/productTypes',
        icon: 'category',
        // role: ['SA', 'admin'],
    },
    {
        name: 'Vendors',
        path: '/vendors',
        icon: 'category',
        // role: ['SA', 'admin'],
    },
    // {
    //     name: 'Edit Product',
    //     path: '/admin/editProduct',
    //     icon: 'dashboard',
    //     role: ['SA', 'admin'],
    // },
    // {
    //     name: 'Event Joinings',
    //     path: '/admin/layouts',
    //     icon: 'category',
    //     // role: ['SA', 'admin'],
    // },
    // {
    //     name: 'Submissions',
    //     path: '/admin/reportedPosts',
    //     icon: 'category',
    //     // role: ['SA', 'admin'],
    // },
    // {
    //     label: 'Components',
    //     type: 'label',
    //     role: ['SA', 'tenant'],
    // },
    // {
    //     name: 'Components',
    //     icon: 'favorite',
    //     role: ['SA', 'tenant'],
    //     badge: { value: '30+', color: 'secondary' },
    //     children: [
    //         {
    //             name: 'Auto Complete',
    //             path: '/material/autocomplete',
    //             iconText: 'A',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Buttons',
    //             path: '/material/buttons',
    //             iconText: 'B',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Checkbox',
    //             path: '/material/checkbox',
    //             iconText: 'C',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Dialog',
    //             path: '/material/dialog',
    //             iconText: 'D',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Expansion Panel',
    //             path: '/material/expansion-panel',
    //             iconText: 'E',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Form',
    //             path: '/material/form',
    //             iconText: 'F',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Icons',
    //             path: '/material/icons',
    //             iconText: 'I',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Menu',
    //             path: '/material/menu',
    //             iconText: 'M',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Progress',
    //             path: '/material/progress',
    //             iconText: 'P',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Radio',
    //             path: '/material/radio',
    //             iconText: 'R',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Switch',
    //             path: '/material/switch',
    //             iconText: 'S',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Slider',
    //             path: '/material/slider',
    //             iconText: 'S',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Snackbar',
    //             path: '/material/snackbar',
    //             iconText: 'S',
    //             role: ['SA', 'tenant'],
    //         },
    //         {
    //             name: 'Table',
    //             path: '/material/table',
    //             iconText: 'T',
    //             role: ['SA', 'tenant'],
    //         },
    //     ],
    // },
    // {
    //     name: 'Charts',
    //     icon: 'trending_up',
    //     role: ['SA', 'tenant'],
    //     children: [
    //         {
    //             name: 'Echarts',
    //             path: '/charts/echarts',
    //             iconText: 'E',
    //             role: ['SA', 'tenant'],
    //         },
    //     ],
    // },
    // {
    //     name: 'Documentation',
    //     icon: 'launch',
    //     role: ['SA', 'tenant'],
    //     type: 'extLink',
    //     path: 'http://demos.ui-lib.com/matx-react-doc/',
    // },
]
